<template>
    <div class="animated fadeIn">
        <b-form @submit="save">
            <b-row>
                <b-col cols="6" :xl="this.$attrs.xl || 6">
                    <transition name="slide">
                        <b-card>
                            <InputField name="name" :label="this.$t('name')" v-model="model.name" @error="fieldError"
                                :rules="{ required: true, length: { min: 2 } }" />

                            <b-form-group :label-cols="1" :horizontal="true">
                                <button class="btn btn-success float-right" type="submit">{{ $t('save') }}</button>
                            </b-form-group>
                        </b-card>
                    </transition>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"

export default {
    name: "Create",
    components: {
        InputField: Input,
        SelectField: Select
    },
    data: function () {
        return {
            errors: [],
            accounts: [],
            model: {
                name: "",
                account_uuid: null
            }
        }
    },
    methods: {
        save(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$mainDialog.msgBoxOk(this.$t('fieldsNotValid'))

                return
            }

            this.$http.post("/v1/project/create", this.model).then(resp => {

                this.$bvToast.toast("Project created", {
                    variant: 'success',
                    title: "Success"
                })

                this.$store.commit("RELOAD_CONTAINER")

                this.$router.push({ path: "/admin/projects" })

                this.$emit("created", resp.data)
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$mainDialog.msgBoxOk(error.response.data.message)
            })
        },
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },
    },

    mounted() {
        this.$http.get("/v1/user/register/accounts").then(resp => {
            this.accounts = resp.data
            this.model.account_uuid = resp.data[0].uuid
        })
    }
}
</script>
